module.exports = __webpack_public_path__ + "img/image-boleto.dddcb06a.jpg";